<template>
  <div class="home">
    <Top :titleName="'追尚协议和规则'" :isBack="false" />
    <div class="content">
      <div
        class="item"
        v-for="(item, index) in titleList"
        :key="index"
        @click="$router.push(item.url)"
      >
        <div class="item_name">
          <span>{{ item.name }}</span>
        </div>
        <div class="item_name"><span class="to_page"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from "../components/top.vue";
export default {
  components: { Top },
  data() {
    return {
      titleList: [
        {
          name: "用户服务协议",
          url: "/serve",
        },
        {
          name: "隐私政策",
          url: "/selfish",
        },
        {
          name: "团购用户条款",
          url: "/group",
        },
        {
          name: "美业服务提供者审查登记规范",
          url: "/check",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  background-color: #f3f3f3;
}
.content {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  .item {
    padding: 0 10px;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    &:nth-child(4) {
      border: none;
    }
    .item_name {
      font-size: 12px;
      width: 50%;
      &:nth-child(2) {
        text-align: right;
      }
      .to_page {
        border-right: 1px solid #a4a1a1;
        border-bottom: 1px solid #a4a1a1;
        display: inline-block;
        width: 5px;
        height: 5px;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
